import { z } from 'zod/v4';

import { QuoteRequestFieldNameRuntype } from '../quote-request/quoteRequestBackendTypes';

export type QuoteRequestTemplateDTO = z.infer<typeof QuoteRequestTemplateDTORuntype>;
export const QuoteRequestTemplateDTORuntype = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    is_default: z.boolean(),
    include_project_name: z.boolean(),
    include_customer_name: z.boolean(),
    required_fields: z.array(QuoteRequestFieldNameRuntype),
    hidden_fields: z.array(QuoteRequestFieldNameRuntype),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
    include_pcb_specification: z.boolean().optional().default(true),
    include_panel_specification: z.boolean().optional().default(true),
    include_custom_part_attachments: z.boolean().optional().default(true),
    include_excel_quote_request: z.boolean().optional().default(true),
    include_exchange_rates: z.boolean().optional().default(true),
});

export type QuoteRequestTemplateInputDTO = z.infer<typeof QuoteRequestTemplateInputDTORuntype>;
export const QuoteRequestTemplateInputDTORuntype = z.object({
    name: z.string(),
    description: z.string().nullable(),
    is_default: z.boolean(),
    include_project_name: z.boolean(),
    include_customer_name: z.boolean(),
    required_fields: z.array(QuoteRequestFieldNameRuntype),
    hidden_fields: z.array(QuoteRequestFieldNameRuntype),
    include_pcb_specification: z.boolean(),
    include_panel_specification: z.boolean(),
    include_custom_part_attachments: z.boolean(),
    include_excel_quote_request: z.boolean(),
    include_exchange_rates: z.boolean(),
});
